import { StudentContext } from "Context/StudentContext";
import StudentDetailsTab from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceTabs/StudentDetailsTab";
import StudentPortfolioMainDestop from "Pages/StudentPortfolio/StudentPortfolioMainDesktop";
import StudentPortfolioMainMobile from "Pages/StudentPortfolio/StudentPortfolioMainMobile";
import { useContext, useState } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import StudentLopMain from "Pages/StudentPortfolio/StudentLOPSection/StudentLopMain";
import StudentPerformancemainHome from "Pages/BranchHealth/Student/StudentPerformancemainHome";
import StudentAttendanceMain from "Pages/StudentPortfolio/StudentAttendanceSection/StudentAttendancemain";
import StudentEngagementHome from "Pages/StudentPortfolio/StudentEngagement/StudentEngagementHome";
import StudentInsightHome from "Pages/StudentPortfolio/StudentInsight/StudentInsightHome";
import ConceptKundali from "Pages/StudentPortfolio/ConceptKundali/ConceptKundali";
export interface CommentObjInterface {
  allComments: any[];
  followUpComments: any[];
  ptmComments: any[];
  absenteeComments: any[];
}
const StudentPortfolioMain = ({
  isPerformanceVisible,
  setIsPerformanceVisible,
  kundaliUrl,
}: any) => {
  const { selectedStudent } = useContext<any>(StudentContext);
  const { screen }: any = useWindowSize();
  const [commentsObj, setCommentsObj] = useState<CommentObjInterface>({
    allComments: [],
    followUpComments: [],
    ptmComments: [],
    absenteeComments: [],
  });
  const tabs = [
    {
      label: "Performance",
      value: "Performance",
      component: <StudentPerformancemainHome />,
    },
    {
      label: "Kundali",
      value: "Kundali",
      component: <ConceptKundali kundaliUrl={kundaliUrl} />,
    },
    {
      label: "Attendance",
      value: "Attendance",
      component: (
        <>
          <StudentAttendanceMain />
        </>
      ),
    },
    {
      label: "LOP",
      value: "Left Out Probability",
      component: (
        <>
          <StudentLopMain />
        </>
      ),
    },
    {
      label: "Student Details",
      value: "Student Details",
      component: <StudentDetailsTab />,
    },
    {
      label: "Engagement",
      value: "Engagement",
      component: <StudentEngagementHome />,
    },
  ];
  const mobileTabs = [
    {
      label: "Student Insight",
      value: "Insight",
      component: <StudentInsightHome />,
    },
  ];
  return (
    <>
      {["xxl", "xl", "lg"].includes(screen) ? (
        <StudentPortfolioMainDestop
          isPerformanceVisible={isPerformanceVisible}
          setIsPerformanceVisible={setIsPerformanceVisible}
          selectedStudent={selectedStudent}
          tabs={
            kundaliUrl != null
              ? tabs
              : tabs.filter((tab) => tab.value !== "Kundali")
          }
          commentsObj={commentsObj}
          setCommentsObj={setCommentsObj}
        />
      ) : (
        <StudentPortfolioMainMobile
          selectedStudent={selectedStudent}
          tabs={
            kundaliUrl != null
              ? [...tabs, ...mobileTabs]
              : [
                  ...tabs.filter((tab) => tab.value !== "Kundali"),
                  ...mobileTabs,
                ]
          }
          commentsObj={commentsObj}
          setCommentsObj={setCommentsObj}
        />
      )}
    </>
  );
};
export default StudentPortfolioMain;
